<template>
  <div class="visit-room">
    <span v-if="error" class="visit-room-err">
      {{ error }}
    </span>
    <v-progress-linear v-if="loading" indeterminate color="primary" />
    <div v-if="encounter">
      <div class="visit-room-header">
        <v-chip v-if="roomIsStarted && !roomIsFinished && timer" label color="red darken-1" dark>
          {{ timer }}
        </v-chip>
        <span class="visit-room-header-select">{{ $t("visits.visitRoomWith") }} {{ encounter.practitioner.name }}</span>
        <div class="visit-room-header-bordered">
          <v-icon color="icon">mdi-calendar-blank</v-icon>
          <p>{{ dateFormated }}</p>
        </div>
        <div class="visit-room-header-bordered">
          <v-icon color="icon">mdi-clock-outline</v-icon>
          <p>{{ timeRange }}</p>
        </div>
      </div>
      <v-row class="visit-room-content" no-gutters>
        <VideoRoom v-if="!roomIsFinished && room" :call-time="timer" />
        <span class="visit-room-err" v-if="room && roomIsFinished">
          {{ $t("visits.errors.finished") }}
        </span>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import VideoRoom from "@/components/VideoRoom";

import { snackBarEventBus, snackBarEventName } from "../../../eventBuses/snackBar.eventBus";
import { visitRoomMixin } from "../../../mixins/visitRoom";

export default {
  components: {
    VideoRoom,
  },
  mixins: [visitRoomMixin],
  methods: {
    ...mapActions(["getCustomTokenRoom", "signInWithCustomToken", "refreshToken"]),
    async fetchRoom() {
      this.error = null;
      const roomId = this.$route.params.roomId || this.$route.params.encounterId;

      const { inviteId, password } = this.$route.query;
      if (!inviteId || !password || !roomId) {
        const err = this.$t("visits.errors.linkError");
        snackBarEventBus.$emit(snackBarEventName, { message: err, type: "error" });
        this.error = err;
        return;
      }
      this.loading = true;
      try {
        await this.getCustomTokenRoom({ inviteId, password });
        await this.signInWithCustomToken();
        await this.refreshToken();
        await this.clear();
        this.encounter = await this.getEncounter(roomId);
      } catch (e) {
        this.error = e.message || e;
        snackBarEventBus.$emit(snackBarEventName, { message: e.message || e, type: "error" });
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.visit-room-err {
  margin: 100px auto;
  font-size: 25px;
}
</style>
